import React, { useState } from 'react'
import { useSelector, useDispatch } from "react-redux";
import { Button, Box, Dialog, DialogContent } from '@mui/material'

import {
  DataGrid,
  gridPaginatedVisibleSortedGridRowIdsSelector,
  gridSortedRowIdsSelector,
  GridToolbarContainer,
  gridVisibleSortedRowIdsSelector,
  useGridApiContext,
  GridToolbarExportContainer,
} from '@mui/x-data-grid';
import { createSvgIcon } from '@mui/material/utils';
import { motion, AnimatePresence } from "framer-motion/dist/framer-motion"
import { selectAdminParticipants } from '../../../reducers/admincenter_participants';

import ParticipantMainDialog from './ParticipantMainDialog';
import { participantdemographicClear } from '../../../reducers/admincenter_participantdemographics';
import { participantaddressClear } from '../../../reducers/admincenter_participantaddress';
import { participantphoneClear } from '../../../reducers/admincenter_participantphone';
import { participantmiscClear } from '../../../reducers/admincenter_participantmisc';
import { contextUpsert, selectContextEntities } from '../../../reducers/global_contexts';
/**
 * 
 {
        "RowNum":9223372036854775807,
        "ParticipantID":2147483647,
        "ParticipantGuid":"String content",
        "FirstName":"String content",
        "LastName":"String content",
        "UserName":"String content",
        "GroupID":2147483647,
        "GroupName":"String content",
        "Status":2147483647,
        "StatusDisplay":"String content",
        "BioDOB":"String content",
        "LastHRAStarted":"String content",
        "LastLogin":"String content"
    }
 */
const DataReportTable = (props) => {
  const {rowWidth, tableHeight}=props
  const dispatch = useDispatch()
  const DataReportStatus = useSelector(state => state.datareports.status)

  const DataReport = useSelector(state=> state.datareports.entities)
  const IsData = DataReport.length>0 ? true : false
  const DataReportColumns = IsData ? Object.keys(DataReport[0]).map(x=>{return {field: x, headerName: x, editable: false, minWidth:rowWidth?rowWidth:200, flex: 1}}) : [] 
  const DataReportData = IsData ? DataReport.map((x,i)=> {return {...x, RowId:i}} ) : []
    //console.log('data report', {d:DataReport, i:IsData, c:DataReportColumns, dd:DataReportData})
  const getUnfilteredRows = ({ apiRef }) => gridSortedRowIdsSelector(apiRef);
  const getFilteredRows = ({ apiRef }) => gridVisibleSortedRowIdsSelector(apiRef);

  const Contexts = useSelector(state => selectContextEntities(state))
  const { showArchivedParticipants } = Contexts
 
  


  const ExportIcon = createSvgIcon(
    <path d="M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z" />,
    'SaveAlt',
  );


  const CustomToolbar = () => {
    const apiRef = useGridApiContext();

    const handleExport = (options) => apiRef.current.exportDataAsCsv(options);

    const buttonBaseProps = {
      color: 'primary',
      size: 'small',
      startIcon: <ExportIcon />,
    };

    return (
      <GridToolbarContainer>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getFilteredRows })}
        >
          Filtered rows
        </Button>
        <Button
          {...buttonBaseProps}
          onClick={() => handleExport({ getRowsToExport: getUnfilteredRows })}
        >
          Unfiltered rows
        </Button>
      </GridToolbarContainer>
    );
  };


  return (
    <Box sx={{ height: tableHeight ? tableHeight+"px" : "700px", p:2 }}>
      <DataGrid
        rows={DataReportData}
        columns={DataReportColumns}
        getRowId={(row) => row.RowId}
        density="compact"
        disableSelectionOnClick
        loading={DataReportStatus==='success'?false:true}
        components={{ Toolbar: CustomToolbar }}
      // pageSize={5}
      // rowsPerPageOptions={[5]}
      // checkboxSelection
      // disableSelectionOnClick
      // experimentalFeatures={{ newEditingApi: true }}
      />
      
    </Box>
  )

}
export default DataReportTable